(function ($) {
    $(function () {
        var queryParamsArray = null;

        var getQueryParams = function(){
            if(queryParamsArray!=null) return queryParamsArray;
            var sPageURL = decodeURIComponent(window.location.search.substring(1));
            var sURLVariables = sPageURL.split('&');
            var paramsArray = {};
            for(var ind in sURLVariables){
                var tmp = sURLVariables[ind].split('=');
                var val = (typeof(tmp[1])=='string' && tmp[1]!="")?tmp[1]:"";
                paramsArray[tmp[0]] = val;
            }
            queryParamsArray = paramsArray;
            return queryParamsArray;
        };
        var buildQueryParams = function(paramsArray){
            var queryStr = "";
            for(var key in paramsArray){
                var tmpStr = key+"="+paramsArray[key];
                if(queryStr!="") tmpStr = '&'+tmpStr;
                queryStr+=tmpStr;
            }
            return queryStr;
        };
        var buildUrl = function(queryString){ return window.location.origin+window.location.pathname+"?"+queryString; };

        function init(){
            getQueryParams();
            $('.filter-select-input').on('change', function(e){
                var select = $(this);
                var key = select.data('filter_key');
                var val = select.val();

                if(val != "default"){
                    queryParamsArray[key] = val;
                }else if(typeof(queryParamsArray[key]) != "undefined"){
                    delete queryParamsArray[key];
                }

                var queryString = buildQueryParams(queryParamsArray);
                window.location = buildUrl(queryString);
            })
        }

        init();
    });
})(jQuery);
